<template>
  <div>
    <!-- <p>Naver Login Access Pages</p>
    <div id="naverArea"></div> -->
    <!-- <div><button type="button" class="btn btn-primary" @click="look()">LookToken</button></div> -->
  </div>
</template>

<script>
import {genCode} from '../assets/js/genCode'
import {insPushHistory} from '../assets/js/push'

export default {
  data() {
    return {
      nToken: "",
      naverAccount: {}
    }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      return this.$store.state.user;
    }
  },
  created() {
  },
  mounted() {
    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
      // console.log('isApp:', this.isApp);
    }
    else 
    {
      this.isApp = false;
      // console.log('isApp:', this.isApp);
    }

    //var naver_id_login = new window.naver_id_login("ZWHmhzE6YbpdaPkpRVxP", "http://localhost/naverCallBack");
    var naver_id_login = new window.naver_id_login("ZWHmhzE6YbpdaPkpRVxP", "https://ntabi.co.kr/naverCallBack");
    // 접근 토큰 값 출력
    this.nToken = naver_id_login.oauthParams.access_token;
    //console.log("nToken:",this.nToken);
    
    // 네이버 사용자 프로필 조회
    naver_id_login.get_naver_userprofile(naverSignInCallback);
    // 네이버 사용자 프로필 조회 이후 프로필 정보를 처리할 callback function
    function naverSignInCallback() {
      const email = naver_id_login.getProfileData('email');
      const name = naver_id_login.getProfileData('name');
      const birthday = naver_id_login.getProfileData('birthday');
      const mobile = naver_id_login.getProfileData('mobile');
      const nickname = naver_id_login.getProfileData('nickname');
      const gender = naver_id_login.getProfileData('gender');
      //const age = naver_id_login.getProfileData('age');

      console.log(name, gender);
      let nEmail = email;
      let nName = nickname;
      let nBirthday = birthday;
      let nMobile = mobile;
      let naverAccount = []
      naverAccount.push(nEmail,nName,nBirthday,nMobile);
    }
    this.lookUpProfile();
  },
  methods: {
    //회원프로필 조회 api연동
    async lookUpProfile() {
      await this.$api("/api/member", {
        // 라우터에서 sql호출시, 파라메타를 같이 넘긴다
        // 처음 파라메터: 기존여부체크용, 두번째 파라메터: 업데이트용
        param: [
          {token: this.nToken}
        ]
      })
      //.then((res) => {console.log("res:",res.response)})
      .then((res) => {this.naverAccount = res.response
        ,this.login()
        //this.acceptJoinUs()
      })
    },

    // 보안강화를 위한 백엔드에서 세션처리로직으로 변경 (2026-06-06)
    async login() {
      const res_checkEmail = await this.$api("/api/checkMemEmail", {
        param: [this.naverAccount.email]
      })

      // 미가입 → 간편가입 절차
      if (!res_checkEmail.length) 
      {
        this.acceptJoinUs()
        return
      }

      // ✅ 추가 — 가입 경로 체크
      const joinFlag = res_checkEmail[0].joinFlag
      if (joinFlag !== 'N') 
      {
        const flagMap = { 'K': '카카오', 'E': '홈페이지', 'H': '관리자등록' }
        const joinTypeName = flagMap[joinFlag] ?? '다른 방법'
        this.$swal.fire(
          "",
          `${joinTypeName}로 가입된 계정입니다.\n${joinTypeName} 로그인을 이용해 주세요.`,
          "warning"
        )
        this.$router.push("/b2cLogin")
        return
      }

      // ── 기존 회원 로그인 ───────────────────────────────────────
      const pad = (n) => String(n).padStart(2, '0')
      const now = new Date()
      const insDate = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ` +
                      `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`

      const naverAccount1 = {
        uEmail:    this.naverAccount.email,
        uNickName: this.naverAccount.name,
        uBirthday: this.naverAccount.birthday,
        alimCallC: this.naverAccount.mobile,
        uPhone:    this.naverAccount.mobile,
        joinFlag:  'N',
        insDate,
      }

      const res = await this.$api("/api/login", {
        param: [naverAccount1, { uNickName: naverAccount1.uNickName }]
      })

      if (!res?.uEmail) 
      {
        this.$swal.fire("", "로그인에 실패하였습니다", "error")
        location.href = "/"
        return
      }

      // ── loginMemberE 로 세션저장 + 멤버십조회 통합 ────────────
      const sessionRes = await this.$api('/api/loginMemberE', {
        param: [{
          email   : res.uEmail,
          nickname: this.naverAccount.name,
        }]
      })

      if (sessionRes?.result !== 'OK') {
        this.$swal.fire("", "로그인 처리 중 오류가 발생했습니다.", "error")
        return
      }

      // 서버가 계산한 membership 을 store에 저장
      this.$store.commit("user", {
        email    : this.naverAccount.email,
        nickname : this.naverAccount.name,
        birthday : this.naverAccount.birthday,
        phone    : this.naverAccount.mobile,
        alimCallC: this.naverAccount.mobile,
        joinFlag : 'N',
        insDate,
        ...sessionRes.membership,   // isActiveMember, memLevel, memNo, memStaDate, memExpDate, paidFlag
      })

      localStorage.setItem('sessionExpiration', Date.now() + 60 * 60 * 1000)

      this.onLoginSuccess(this.naverAccount.email)
      this.$router.push({ path: "/" })
    },

    // 푸시용 토큰등록 나쵸코드와 연동처리
    onLoginSuccess(userId) {
      //alert(userId + "푸시알림을 위해 토큰을 등록합니다-네이버.")
      window.Nachocode.push.registerPushToken(userId).then(async result => 
      {
        if (result.status === 'success') 
        {
          //alert('푸시 토큰이 성공적으로 등록되었습니다-app.vue');

          // 토근생성 후, 포인트적립 조건체크 후 포인트적립 및 푸시알림 발송
          let today = new Date();
          let yyyy = today.getFullYear();
          let mm_tmp = today.getMonth()+1;
          let dd_tmp = today.getDate();
    
          let mm = "";
          if(mm_tmp < 10) {mm = "0" + mm_tmp}
          else mm = mm_tmp;

          let dd = "";
          if(dd_tmp < 10) {dd = "0" + dd_tmp}
          else dd = dd_tmp;
          
          //let joinDate = yyyy +"-" + mm + "-" + dd
          let checkJDate = (yyyy+mm+dd) * 1

          let appPointText = '모바일앱 등록 감사포인트'

          if(checkJDate < 20270101 && this.isApp === true)
          {
            // 기적립 포인트 체크
            let checkDubAppPoint = await this.$api("/api/checkDubAppPoint", {param: [userId]})
            // 기적립 포인트가 없으면 적립진행
            if(checkDubAppPoint.length < 1 || !checkDubAppPoint)
            {
              let evtPlusPoint = await this.$api("/api/evtPlusPoint", { param: [userId, 10000, appPointText] } );
              if(evtPlusPoint.affectedRows < 0)
              {
                this.$swal.fire("","포인트 적립 중 에러가 발생했습니다. 당사 웹사이트나 연락처로 문의주시면 감사하겠습니다", "error")
              }
              else 
              {
                //첫앱다운로드 후 로그인시 특전포인트 1만포인트 적립
                let joinMember = '앱다운로드 후 첫 로그인 기념으로 <span style="color: red; font-weight: 600;">10,000</span>포인트를 적립해 드립니다.'
                
                this.$swal.fire({
                  html: joinMember,
                  imageUrl: '/IMGs/welcome.png',
                  imageWidth: 300,
                  imageHeight: 150,
                  imageAlt: 'WelcomeImage',
                }).then(async () => 
                {
                  // 적립사실을 푸시와 카톡으로 알림
                  await this.push_appPoint(userId)
                  // let pushResult = await push_appPoint(this.$api, userId)  //L:로그인
                  //this.sendKakao_join("JO", joinDate, 'ndt');
                })
              }
            }
          }
        } 
        else 
        {
          console.error(`푸시 토큰 등록 실패: ${result.message}`);
        }
      });
    },

    // 백엔드에 푸시api 연결요청
    async push_appPoint(uId) {
      // 앱다운로드 감사포인트 푸시
      let pushMessages = 
      {
        userId: uId,
        title: "엔타비 첫 방문을 환영합니다",
        content: "10,000P가 지급되었습니다. 즐거운 여행 되세요!",
        linkURL: "https://ntabi.co.kr/",
        imageURL:"https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
      };

      // await로 결과값을 변수에 직접 할당
      let result = await this.$api("api/pushSend01", {
        param: [
          { pushMessages: pushMessages }
        ]
      });

      let arr_push = [];
      let pushHistory = [];

      // 푸싱성공->히스토리저장
      if(result == "Push successfully requested to be sent.") 
      {
        arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '200', 'ok', 'PE', 'Y', 'Y'];
        pushHistory = await insPushHistory(this.$api, arr_push);
      }
      else 
      {
        arr_push = [uId, pushMessages.title, pushMessages.content, pushMessages.linkURL, pushMessages.imageURL, pushMessages.userId, '', 'err', 'PE', 'Y', 'Y'];
        pushHistory = await insPushHistory(this.$api, arr_push);
      }

      if(pushHistory === "Y") 
      {
        console.log("History Save OK");
      }
      else 
      {
        console.log("History Save Fail");
      }
    },

    // // 백엔드에 푸시api 연결요청
    // async push_appPoint(uId) {
    //   // 앱다운로드 감사포인트 푸시
    //   let pushMessages = 
    //   {
    //     userId: uId,
    //     title: "App등록 후 첫로그인 감사포인트",
    //     content: "10,000포인트가 적립되었습니다.",
    //     linkURL: "https://ntabi.co.kr",
    //     imageURL:"https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
    //     //pushType: "appPoint",
    //   };

    //   await this.$api("api/pushSend01", {
    //     param: 
    //     [ 
    //       { pushMessages: pushMessages }
    //     ]
    //   }).then((res) => {console.log(res)});
    //   // this.$api("api/pushSend01", {
    //   //   pushMessages: [ pushMessages ]
    //   // }).then((res) => {console.log(res)});
    // },


    // //간편인증자의 멤버십가입자 정보획득
    // async membershipCheck(uEmail){
    //   // console.log(uEmail)
    //   // return []

    //   let checkMembershipYN = ""
    //   checkMembershipYN = await this.$api("/api/checkMembershipYN", {param: [uEmail]})
    //   // console.log("checkMembershipYN:",checkMembershipYN)

    //   if(checkMembershipYN[0].newMem == "Y")
    //   {
    //     let membershipInfo = []
    //     membershipInfo = await this.$api("/api/checkMembershipInfo_new", {param: [uEmail]});
    //     //console.log("membershipInfo:",membershipInfo)
    //     if(membershipInfo.length > 0)
    //     {
    //       return membershipInfo[0]
    //     }
    //   }
    //   else
    //   {
    //     return []
    //   }
    // },
    
    //회원가입확인과정
    async acceptJoinUs(){
      // //임시회원번호생성
      let catCode   = "U-"
      let tmpUserNo = await this.genCode(catCode)
      let joinFlag = "N"
      let useFlag = "Y"
      let birthday = this.naverAccount.birthday.replace(/-/g, '')
      let phone = this.naverAccount.mobile.replace(/-/g, '')

      let ins_memberInfo_tmp = await this.$api("/api/ins_memberInfo_tmp", {param: [
        tmpUserNo, this.naverAccount.email, birthday, this.naverAccount.name, joinFlag, useFlag, phone, this.naverAccount.gender, this.naverAccount.birthyear
      ]});

      if(ins_memberInfo_tmp.affectedRows < 0)
      {
        this.$swal.fire("","간편회원가입 중 에러가 발생했습니다. 재시도를 부탁드립니다.", "warning")
        location.href = "/b2cLogin"
      }
      else
      {
        // this.$router.push({path: '/acceptJoinUs', query: {uNo: tmpUserNo}});
        this.$router.push({ name: 'AcceptJoinUs', params: { uNo: tmpUserNo }})    //파라메타노출방지(path가 아닌 Name에 맞춘다)
      }
    },

    //임시유저번호생성(간편로그인용)
    async genCode(param) {
      let chkFlag = "N";
      let rtnCode = "";

      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++)
      {
        let today = new Date();
        let yy = today.getFullYear().toString().slice(-2);
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ymd = `${yy}${mm}${dd}`;
        let dCd = param + ymd;

        rtnCode = await genCode(this.$api, dCd);
        //console.log("rtnCode:",rtnCode)

        let chk_genCode = await this.$api("/api/checkDub_resCode", { param: [rtnCode] });

        if (chk_genCode.length > 0) {
          chkFlag = "N";
        } else {
          chkFlag = "Y";
        }
      }
      //console.log("chkFlag:", chkFlag)
      if (chkFlag === "N")
      {
        this.$swal.fire("","임시번호 생성횟수 한계에 도달하였습니다.<br>담당자에게 문의(1660-4602)하여 주세요.","warning")
        return false;
      }
      else
      {
        return rtnCode
      }
    },    
  }
}
</script>